// extracted by mini-css-extract-plugin
module.exports = {"edgeLabel":"ZapStepEdge_edgeLabel__yta8G"};